var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_28_4868)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_4868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 17.3333C13.4726 17.3333 12.957 17.1769 12.5185 16.8839C12.0799 16.5909 11.7382 16.1744 11.5363 15.6872C11.3345 15.1999 11.2817 14.6637 11.3846 14.1464C11.4875 13.6291 11.7414 13.154 12.1144 12.781C12.4873 12.4081 12.9625 12.1541 13.4798 12.0512C13.997 11.9483 14.5332 12.0012 15.0205 12.203C15.5078 12.4048 15.9242 12.7466 16.2173 13.1851C16.5103 13.6237 16.6667 14.1393 16.6667 14.6667C16.6667 15.3739 16.3857 16.0522 15.8856 16.5523C15.3855 17.0524 14.7072 17.3333 14 17.3333ZM18 20C18 19.4696 17.7893 18.9609 17.4142 18.5858C17.0391 18.2107 16.5304 18 16 18H12C11.4696 18 10.9609 18.2107 10.5858 18.5858C10.2107 18.9609 10 19.4696 10 20V22H18V20ZM18 11.3333C17.4726 11.3333 16.957 11.1769 16.5185 10.8839C16.0799 10.5909 15.7382 10.1744 15.5363 9.68716C15.3345 9.19989 15.2817 8.66371 15.3846 8.14643C15.4875 7.62914 15.7414 7.15399 16.1144 6.78105C16.4873 6.40811 16.9625 6.15413 17.4798 6.05124C17.997 5.94835 18.5332 6.00116 19.0205 6.20299C19.5078 6.40482 19.9242 6.74662 20.2173 7.18515C20.5103 7.62368 20.6667 8.13925 20.6667 8.66667C20.6667 9.37391 20.3857 10.0522 19.8856 10.5523C19.3855 11.0524 18.7072 11.3333 18 11.3333ZM10 11.3333C9.47258 11.3333 8.95701 11.1769 8.51848 10.8839C8.07995 10.5909 7.73816 10.1744 7.53632 9.68716C7.33449 9.19989 7.28168 8.66371 7.38457 8.14643C7.48747 7.62914 7.74144 7.15399 8.11438 6.78105C8.48732 6.40811 8.96248 6.15413 9.47976 6.05124C9.99704 5.94835 10.5332 6.00116 11.0205 6.20299C11.5078 6.40482 11.9242 6.74662 12.2173 7.18515C12.5103 7.62368 12.6667 8.13925 12.6667 8.66667C12.6667 9.37391 12.3857 10.0522 11.8856 10.5523C11.3855 11.0524 10.7072 11.3333 10 11.3333ZM10 14.6667C9.99965 13.6816 10.3648 12.7314 11.0247 12H8C7.46957 12 6.96086 12.2107 6.58579 12.5858C6.21071 12.9609 6 13.4696 6 14V16H10.2327C10.0796 15.5721 10.0009 15.1211 10 14.6667ZM17.7673 16H22V14C22 13.4696 21.7893 12.9609 21.4142 12.5858C21.0391 12.2107 20.5304 12 20 12H16.9753C17.4569 12.5327 17.785 13.186 17.9244 13.8905C18.0639 14.5949 18.0096 15.324 17.7673 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4868",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_4868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.f04550549e5fbd95a1be53ce2abcead3.svg";
export { ForwardRef as ReactComponent };